import { render, staticRenderFns } from "./BlocTextList.vue?vue&type=template&id=5acb7578"
import script from "./BlocTextList.vue?vue&type=script&lang=ts"
export * from "./BlocTextList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports